import { render, staticRenderFns } from "./AdminCate1.vue?vue&type=template&id=f043646e&scoped=true&"
import script from "./AdminCate1.vue?vue&type=script&lang=js&"
export * from "./AdminCate1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f043646e",
  null
  
)

export default component.exports